module.exports = __webpack_public_path__ + "static/media/Electrical.c8431a83.png";